export function constructTypeMap<T extends string>(
  indexMap: Record<T, number>,
): Record<number, T> {
  return Object.fromEntries(
    Object.entries(indexMap).map(([key, value]) => [value, key]),
  ) as Record<number, T>;
}
